import flat from 'flat';

import accessibility from '@i18n/accessibility';
import countries from '@i18n/countries';
import dictionary from '@i18n/dictionary';
import errors from '@i18n/errors';
import forms from '@i18n/forms';
import languages from '@i18n/languages';
import menus from '@i18n/menus';
import models from '@i18n/models';
import notifications from '@i18n/notifications';
import pages from '@i18n/pages';
import pageTitles from '@i18n/pageTitles';
import timezones from '@i18n/timezones';

const nestedTranslations = {
  accessibility,
  countries,
  dictionary,
  errors,
  forms,
  languages,
  menus,
  models,
  notifications,
  pageTitles,
  pages,
  timezones
};

type Translations = {
  [key: string]: string;
};

const en: Translations = flat.flatten(nestedTranslations);

export default en;
